/** Placeholder while a lazily loaded screen arrives; the shell around it stays put. */
export const Pending = () => <p className="max-w-[1200px] mx-auto px-7 py-7 text-body-sm text-ink-2">Loading…</p>;
